import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Cabinet } from '../../../lib/modelBuilder/entities/Cabinet';
import CrossPieceSchemaDimensions from './CrossPieceSchemaDimensions';
import { Shelf } from '../../../lib/modelBuilder/entities/Shelf';
import ShelfSchemaDimensions from './ShelfSchemaDimensions';
import FeetsSchemaDimensions from './FeetsSchemaDimensions';
import { CabinetSupport } from '../../../lib/modelBuilder/constants';
import { RATIO_HEIGHT_PIXEL_TO_REAL_SIZE } from '../constants';
import WheelsSchemaDimensions from './WheelsSchemaDimensions';

interface Props {
  cabinet: Cabinet;
}

const CabinetSchemaDimensions = ({ cabinet }: Props) => {
  const cabinetRows = (): string => {
    let result = '40fr';
    cabinet.shelves
      .sort((a: Shelf, b: Shelf) => b.level - a.level)
      .map((shelf: Shelf) => (result += ` ${shelf.height}fr 40fr`));
    if (cabinet.feets && cabinet.feets[0])
      result += ` ${cabinet.feets[0].height}fr`;
    return result;
  };

  const cabinetHeight =
    cabinet.wheels && cabinet.wheels[0]
      ? cabinet.height - cabinet.bottomSupportHeight
      : cabinet.height;

  return (
    <StyledCabinetSchema
      widthCabinet={cabinet.width}
      groundOffset={cabinet.groundOffset}
    >
      <StyledCornersAndShelvesSchema heightCabinet={cabinetHeight}>
        <StyledCornerSchema />
        <StyledContentSchema
          heightCabinet={cabinetHeight}
          cabinetRows={cabinetRows()}
        >
          <CrossPieceSchemaDimensions />
          {cabinet.shelves
            .sort((a: Shelf, b: Shelf) => b.level - a.level)
            .map((shelf: Shelf) => (
              <ShelfSchemaDimensions key={shelf.level} shelf={shelf} />
            ))}
          {cabinet.feets && cabinet.feets[0] ? (
            <FeetsSchemaDimensions feetsHeight={cabinet.bottomSupportHeight} />
          ) : null}
        </StyledContentSchema>
        <StyledCornerSchema />
      </StyledCornersAndShelvesSchema>
      {cabinet.wheels && cabinet.wheels[0] ? (
        <WheelsSchemaDimensions wheelsHeight={cabinet.bottomSupportHeight} />
      ) : null}
    </StyledCabinetSchema>
  );
};

const StyledCabinetSchema = styled.div<{
  widthCabinet: number;
  groundOffset: number;
}>`
  width: ${p => Math.round(p.widthCabinet * RATIO_HEIGHT_PIXEL_TO_REAL_SIZE)}px;
  margin-bottom: ${p =>
    Math.round((p.groundOffset / 2) * RATIO_HEIGHT_PIXEL_TO_REAL_SIZE)}px;
  height: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

const StyledCornersAndShelvesSchema = styled.div<{
  heightCabinet: number;
}>`
  height: ${p =>
    Math.round(p.heightCabinet * RATIO_HEIGHT_PIXEL_TO_REAL_SIZE)}px;
  width: 100%;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 8px auto 8px;
`;

const StyledCornerSchema = styled.div`
  border: 1px solid black;
`;

const StyledContentSchema = styled.div<{
  heightCabinet: number;
  cabinetRows: string;
}>`
  display: grid;
  grid-template-rows: ${p => p.cabinetRows};
  grid-template-columns: auto;
  height: ${p =>
    Math.round(p.heightCabinet * RATIO_HEIGHT_PIXEL_TO_REAL_SIZE)}px;
`;

export default CabinetSchemaDimensions;
